
// src/connects/kpi-form-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'
import { getArray } from '../helpers/store'
import { validate } from '../helpers/form-validator'
import { emitAlertMessage } from '../actions/alert-message'
import moment from 'moment'
import map from 'lodash/map'
import some from 'lodash/some'
import find from 'lodash/find'
import each from 'lodash/each'
import filter from 'lodash/filter'
import keys from 'lodash/keys'

function cloneProps(props, key, value) {
  if (props.kpi)
    return props.kpi[key]
  else if (props.cloneKpi)
    return props.cloneKpi[key]
  else
    return value
}

function copyName(props, suffix) {
  if (props.kpi)
    return props.kpi.name
  else if (props.cloneKpi && suffix)
    return props.cloneKpi.name + ' ' + suffix
  else
    return ''
}

function cloneAssignments(props) {
  var clone = cloneProps(props, 'assignments', props.group.members)
  return map(props.group.members, (member)=> {
    var assign = find(clone, (item)=> item.user_id == member.user_id)
    return ({
      id: member.user_id,
      name: member.name,
      icon_image: member.icon_image,
      assign: typeof assign != 'undefined',
      target: assign && assign.target || '',
    })
  })
}

export function assignAll(assignments, value) {
  return map(assignments, (assign)=> {
    return Object.assign({}, assign, { assign: value })
  })
}

export function assignTargetAll(assignments, value) {
  return map(assignments, (assign)=> {
    if (assign.assign)
      return Object.assign({}, assign, { target: value })
    else
      return assign
  })
}


export function isAssignAll(assignments) {
  return !some(assignments, (assign)=> !assign.assign)
}

export const mapStateToProps = (state, ownProps)=> {
  return {
    group: getArray('group_id', state.groups.items, ownProps.group.group_id),
    isUpdating: state.kpi.isUpdating,
    isUpdateFailed: state.kpi.isUpdateFailed,
    kpi: ownProps.kpi_id && state.kpi.items && find(state.kpi.items, (item)=> item.kpi_id == ownProps.kpi_id),
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    validateAndSubmit: (props, event = undefined)=> {
      if (event && event.preventDefault)
        event.preventDefault()
      var rules = {
        name: { rule: 'isRequired' },
        unit: { rule: 'isRequired' },
      }
      validate(props.ui, rules, (errors, nextUI)=> {
        each(props.ui.assignments, (assign, i)=> {
          if (assign.assign && !assign.target.toString().match(/^[-.,0-9]+$/)) {
            if (!nextUI.assignments)
              nextUI.assignments = Object.assign({}, props.ui.assignments)
            nextUI.assignments[i].targetError = true
            errors = true
          }
        })
        if (moment(props.ui.startDate).isAfter(moment(props.ui.endDate))) {
          nextUI.startDateError = true
          nextUI.endDateError = true
          errors = true
          dispatch(emitAlertMessage('label:開始日は終了日より前に設定してください', 'error'))
        }
        if (props.ui.generateNextAtDaysTarget && moment(props.ui.generateNextAtDays).isBefore(moment(props.ui.startDate))) {
          nextUI.generateNextAtDaysError = true
          nextUI.startDateError = true
          errors = true
          dispatch(emitAlertMessage('label:自動作成日は開始日より後に設定してください', 'error'))
        }
        if (props.ui.generateNextAtDaysTarget && moment(props.ui.generateNextAtDays).isAfter(moment(props.ui.endDate))) {
          nextUI.generateNextAtDaysError = true
          nextUI.endDateError = true
          errors = true
          dispatch(emitAlertMessage('label:自動作成日は終了日より前に設定してください', 'error'))
        }
        props.updateUI(nextUI)
        const copyStart = props.ui.generateNextAtDaysTarget ? props.ui.generateNextAtDays && moment(props.ui.generateNextAtDays) || undefined : undefined
        const end_date =  props.ui.generateNextAtDaysTarget ? moment(props.ui.endDate) : undefined  
        const diff_date = props.ui.generateNextAtDaysTarget ? copyStart >= 0 && end_date.diff(copyStart, 'days') || 0 : undefined //終了日と自動作成が同じ日の場合0を返す。
        
        if (!errors) {
          if (props.kpi)
            dispatch(actions.updateKpi(
              props.kpi.kpi_id,
              props.ui.name,
              props.ui.unit,
              props.group.group_id,
              props.ui.startDate.format('YYYY-MM-DD'),
              props.ui.endDate.format('YYYY-MM-DD'),
              diff_date,
              props.ui.displayFormat,
              props.ui.prependUnit,
              props.ui.accumulatedTotal,
              JSON.stringify(filter(props.ui.assignments, (assign)=> assign.assign).map((assign)=> ({ user_id: assign.id, target: assign.target }))),
            ))
          else
            dispatch(actions.createKpi(
              props.ui.name,
              props.ui.unit,
              props.group.group_id,
              props.ui.startDate.format('YYYY-MM-DD'),
              props.ui.endDate.format('YYYY-MM-DD'),
              diff_date,
              props.ui.displayFormat,
              props.ui.prependUnit,
              props.ui.accumulatedTotal,
              JSON.stringify(filter(props.ui.assignments, (assign)=> assign.assign).map((assign)=> ({ user_id: assign.id, target: assign.target }))),
            ))
        }
      })
      return false
    },

    willMount: (props)=> props.kpi_id && dispatch(actions.fetchKpi(props.kpi_id)),

    willUpdate: (props, nextProps)=> {
      if (!props.kpi && nextProps.kpi) {
        nextProps.updateUI({
          name: nextProps.kpi.name,
          unit: nextProps.kpi.unit,
          startDate: moment(nextProps.kpi.start_date),
          endDate: moment(nextProps.kpi.end_date),
          generateNextAtDays: calcGenerateNextAtDays(nextProps),
          displayFormat: keys(nextProps.kpi.display_format).sort().join(' ') || '',
          prependUnit: nextProps.kpi.prepend_unit,
          accumulatedTotal: nextProps.kpi.accumulated_total,
          generateNextAtDaysTarget: nextProps.kpi.generate_next_at_days >= 0,
          assignments: cloneAssignments(nextProps)
        })
      }

      if (props.isUpdating && !nextProps.isUpdating && !nextProps.isUpdateFailed) {
        nextProps.selectPanel('kpi')
        if (nextProps.kpi_id)
          dispatch(emitAlertMessage({ message: 'label:KPIを更新しました', name: nextProps.kpi.name }, 'inputSuccess'))
        else
          dispatch(emitAlertMessage('label:KPIを作成しました', 'inputSuccess'))
      }
    },

    willUnmount: (props)=> {
      dispatch(actions.fetchDiaryKpi(props.group.group_id, new Date()))
    }
  }
}

export function calcStartDate(props) {
  if (props.kpi){
    return moment(props.kpi.start_date).hours(0).minutes(0).seconds(0).milliseconds(0)
  }
  if (props.cloneKpi && !props.nextPeriod){
    return moment(props.cloneKpi.start_date).hours(0).minutes(0).seconds(0).milliseconds(0)
  }
  if (props.cloneKpi && props.nextPeriod) {
    return moment(props.cloneKpi.end_date).add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0)
  }
  return moment().startOf('day')
  
}

export function calcEndDate(props) {
  if (props.kpi){
    return moment(props.kpi.end_date).hours(0).minutes(0).seconds(0).milliseconds(0)
  }
  if (props.cloneKpi && !props.nextPeriod)
    return moment(props.cloneKpi.end_date).hours(0).minutes(0).seconds(0).milliseconds(0)
  if (props.cloneKpi && props.nextPeriod) {
    const start_date = moment(props.cloneKpi.start_date)
    const end_date = moment(props.cloneKpi.end_date)
    if (start_date.clone().startOf('month').isSame(start_date, 'day') &&
        end_date.clone().endOf('month').isSame(end_date, 'day')) {
      const diff_month = end_date.year() * 12 + end_date.month() - (start_date.year() * 12 + start_date.month()) + 1
      return end_date.clone().add(diff_month, 'month').endOf('month').startOf('day')
    } else {
      const diff_days = moment.duration(end_date.toDate() - start_date.toDate()).days() + 1
      return end_date.clone().add(diff_days, 'days')
    }
  }
  return moment().endOf('month')
}

export function calcGenerateNextAtDays(props) {
  if (props.kpi){
    // generate_next_at_daysが入っている場合は、その日付を計算する
    // 入っていない場合は、end_dateを設定する
    if (props.kpi.generate_next_at_days >= 0)
      return moment(props.kpi.end_date).subtract(props.kpi.generate_next_at_days ,'days' ).startOf('days')
    else
      return moment(props.kpi.end_date).startOf('days')
  }
  else {
    // 新規作成の場合は、endDateを初期値に設定する
    return calcEndDate(props).startOf('days')
  }
}

export default combineHOC(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    name: (props)=> copyName(props, props.t('label:コピー')),
    nameError: undefined,
    unit: (props)=> cloneProps(props, 'unit', ''),
    unitError: undefined,
    todayDate: moment().startOf('days'),
    startDate: (props)=> calcStartDate(props),
    startDateError: undefined,
    endDate: (props)=> calcEndDate(props),
    endDateError: undefined,
    generateNextAtDays: (props)=> calcGenerateNextAtDays(props), // generateNextAtDays: KPIを生成する日付(moment)
    generateNextAtDaysError: undefined, 
    generateNextAtDaysTarget: (props)=> props.kpi && props.kpi.generate_next_at_days >= 0, // generateNextAtDaysTarget: チェックON/OFF
    displayFormat: (props)=> keys(cloneProps(props, 'display_format', { separate_1000: true })).sort().join(' ') || '',
    prependUnit: (props)=> cloneProps(props, 'prepend_unit', false),
    accumulatedTotal: (props)=> cloneProps(props, 'accumulated_total', true),
    assignments: (props)=> cloneAssignments(props),
    assignSameTarget: false,
    assignAll: (props)=> isAssignAll(cloneAssignments(props)),
    isEdited: false,
    assignmentAllValue: undefined,
    assignmentAllError: false
  }}),
  lifecycle,
)



// WEBPACK FOOTER //
// ./src/connects/kpi-form-panel.js